export const router = {
  HOME: '/',
  LOGIN: '/login',
};
